import React  from "react";
import { useParams } from 'react-router-dom';
import { connect } from "react-redux";
import InvoiceForm from "./components/InvoiceForm";
import InvoiceItemTable from "./components/InvoiceItemTable";

const ViewInvoice = ({recordData, ...props}) => {
	const { invoiceId } = useParams();
	
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<InvoiceForm recordId={invoiceId} mode="view"/>
			 	
			 	{recordData && (
			 		<InvoiceItemTable invoiceData={recordData}/>
		      	)}
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  searchFilters: state.payrun.payrunList?.filters,
  recordData: state.invoice.invoiceDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewInvoice);
